'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_StoreGroupView$$anon$5(outer) {
  this.bzC = null;
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
  this.bzC = outer;
}
export { $c_Lpresto_StoreGroupView$$anon$5 as $c_Lpresto_StoreGroupView$$anon$5 };
$p = $c_Lpresto_StoreGroupView$$anon$5.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_StoreGroupView$$anon$5;
/** @constructor */
function $h_Lpresto_StoreGroupView$$anon$5() {
}
export { $h_Lpresto_StoreGroupView$$anon$5 as $h_Lpresto_StoreGroupView$$anon$5 };
$h_Lpresto_StoreGroupView$$anon$5.prototype = $p;
$p.cK6 = (function(r) {
  var this$1 = this.bzC;
  var this$3 = r.xp;
  if (((this$3.e === 1) && (this$3.f === 0))) {
    var this$4 = this$1.K2;
    return ((!this$4.k()) && (this$4.q().fR === "admin"));
  } else {
    return false;
  }
});
$p.zo = (function(item) {
  return this.cK6(item);
});
var $d_Lpresto_StoreGroupView$$anon$5 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_StoreGroupView$$anon$5, "presto.StoreGroupView$$anon$5", ({
  RV: 1,
  cv: 1
}));
export { $d_Lpresto_StoreGroupView$$anon$5 as $d_Lpresto_StoreGroupView$$anon$5 };
//# sourceMappingURL=presto.-Store-Group-View$$anon$5.js.map
